Vendd.Scripts.load(function() {

    var $wrapper = $('.x-cart-shippingwidget'), model, isCalculated = false, previousProductsPrice;

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var formData = {
        countryCode: '',
        postCode: '',
        areaId: 0,
        shippingMethodId: 0,
        shippingCompanyId: 0
    };

    var previousData = Cookies.get("CartShippingData");
    if (previousData) formData = JSON.parse(previousData);

    var firstRun = true;

    wrapper.update = function update() {
        wrapper.loading(true);

        model.CanCalc = false;
        model.CanReset = false;

        if (model.IsCountrySelected) {
            model.CanReset = true;
            if (model.IsPostCodeVisible && model.PostCode) {
                if (model.IsAreaSelected) {
                    if (!model.IsSelectionRequired) {
                        model.CanCalc = true;
                    }
                }
            }
            else if (!model.IsPostCodeVisible) {
                if (model.IsAreaSelected) {
                    if (!model.IsSelectionRequired) {
                        model.CanCalc = true;
                    }
                }
            }
        }

        var html = Vendd.Handlebars.parse("cartShippingWidget_A", model);
        wrapper.bind(html);

        wrapper.loading(false);

        if (firstRun) {
            $wrapper.removeClass('x-initializing');
            firstRun = false;
        }
    };

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.showMessages = function showMessages(success) {
        if (success) {
            $('.js-error', $wrapper).hide();
            $('.js-success', $wrapper).show();
        } else {
            $('.js-error', $wrapper).show();
            $('.js-success', $wrapper).hide();
        };

    };

    wrapper.clearFields = function clearFields(currentField) {

        var $postCodeInput = $('input[type="text"][name="postCode"]', $wrapper);
        var $areaSelect = $('select[name="areaId"]', $wrapper);
        var $ShippingMethodCompany = $('input[type="radio"][name="shippingMethodId-shippingCompanyId"]', $wrapper);

        switch (currentField) {
            case 'countryCode':
                $postCodeInput.val('');
                $areaSelect.val(0);
                $ShippingMethodCompany.prop('checked', false);
                break;
            case 'postCode':
                $areaSelect.val(0);
                $ShippingMethodCompany.prop('checked', false);
                break;
            case 'areaId':
                $ShippingMethodCompany.prop('checked', false);
                break;
        }
    };

    wrapper.getFormData = function getFormData() {

        formData.countryCode = $('select[name="countryCode"]', $wrapper).val();
        formData.postCode = $('input[type="text"][name="postCode"]', $wrapper).val();
        formData.areaId = parseInt($('select[name="areaId"]', $wrapper).val() || 0);

        var $ShippingMethodCompany = $('input[type="radio"][name="shippingMethodId-shippingCompanyId"]:checked', $wrapper);
        formData.shippingMethodId = parseInt($ShippingMethodCompany.length === 1 ? $ShippingMethodCompany.data('shipping-method-id') : 0);
        formData.shippingCompanyId = parseInt($ShippingMethodCompany.length === 1 ? $ShippingMethodCompany.data('shipping-company-id') : 0);

        if (isCalculated) {
            isCalculated = false;
            $('.js-error', $wrapper).hide();
            $('.js-success', $wrapper).hide();

        }
    };

    wrapper.getModel = function getModel() {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetShippingModel(formData.countryCode, formData.postCode, formData.areaId, formData.shippingMethodId, formData.shippingCompanyId));
    }

    wrapper.submit = function submit() {
        wrapper.loading(true);

        wrapper.getFormData();

        $('.js-submit-button', $wrapper).prop('disabled', true).parent().addClass('x-disabled');

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.ApplyShippingData(formData.countryCode, formData.postCode, formData.areaId, formData.shippingMethodId, formData.shippingCompanyId));

        isCalculated = true;
    };

    wrapper.reset = function reset() {
        wrapper.loading(true);

        $('.js-error', $wrapper).hide();
        $('.js-success', $wrapper).hide();
        $('.js-submit-button', $wrapper).prop('disabled', true).parent().addClass('x-disabled');
        $('.js-clear-button', $wrapper).prop('disabled', true).parent().addClass('x-disabled');

        wrapper.clearFields('countryCode');

        formData.countryCode = '';
        formData.postCode = '';
        formData.areaId = 0;
        formData.shippingMethodId = 0;
        formData.shippingCompanyId = 0;

        Cookies.remove('CartShippingData');

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.ApplyShippingData(formData.countryCode, formData.postCode, formData.areaId, formData.shippingMethodId, formData.shippingCompanyId));

        wrapper.getModel();

        isCalculated = false;
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);

        initTooltips();

        $('.js-error', $wrapper).hide();
        $('.js-success', $wrapper).hide();
    };

    $wrapper.on('change', 'select[name="countryCode"]', function () {

        wrapper.clearFields('countryCode');

        wrapper.getFormData();
        wrapper.getModel();
    });

    $wrapper.on('keyup', 'input[type="text"][name="postCode"]', function () {
        removeWhiteSpaces($(this));
    });

    $wrapper.on('keyup', 'input[type="text"][name="postCode"]', $.debounce(850, function () {

        wrapper.clearFields('postCode');

        wrapper.getFormData();
        wrapper.getModel();
    }));

    $wrapper.on('change', 'select[name="areaId"]', function () {

        wrapper.clearFields('areaId');

        wrapper.getFormData();
        wrapper.getModel();
    });

    $wrapper.on('click', 'input[type="radio"][name="shippingMethodId-shippingCompanyId"]', function () {

        wrapper.getFormData();

        if ($('.js-submit-button', $wrapper).parent().hasClass('x-disabled'))
            $('.js-submit-button', $wrapper).prop('disabled', false).parent().removeClass('x-disabled');
    });

    $wrapper.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!$('.js-submit-button', $wrapper).is(":disabled")) {
            wrapper.submit();
        }

    });

    $wrapper.on('click', '.js-clear-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        wrapper.reset();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingDataSuccess, wrapper, function (envelope) {

        if (formData.areaId > 0) {
            Cookies.set("CartShippingData", formData, { samesite: 'Lax' });
            wrapper.showMessages(true);
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());

            //Close fancybox after successfull submit
            setTimeout(function () {
                wrapper.loading(false);
                $.fancybox.close();
            }, 300);
            
        }

    });
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingDataFailed, wrapper, function (envelope) {
        wrapper.loading(false);

        wrapper.showMessages(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModelSuccess, wrapper, function(envelope) {
        model = envelope.message.data.model;
        wrapper.update();
    });
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModelFailed, wrapper, function(envelope) {
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {

        var productsCount = envelope.message.data.Cart.ProductsCount;
        var productstotalPrice = envelope.message.data.Cart.Summary.TotalPrice;
        if (productsCount > 0) {
            $wrapper.closest('.js-widget-container').show();
        } else {
            $wrapper.closest('.js-widget-container').hide();
        }

        if (previousProductsPrice !== productstotalPrice)
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetShippingModel(formData.countryCode, formData.postCode, formData.areaId, formData.shippingMethodId, formData.shippingCompanyId));
        previousProductsPrice = productstotalPrice;
    });
    

});
